const $ = jQuery.noConflict();

'use strict';
const Header = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */
	$domHeader: $('.site-header'),
	classHeaderScroll: 'is-sticky',

	/** @description Initialize */
	init: function() {
		this.headerScroll();
		this.headerStickyOnLoad();
	},

	headerScroll: function() {
		$(document).on('scroll', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	},

	headerStickyOnLoad: function() {
		$(window).on('load', function() {
			const scrollTop = $(document).scrollTop();
			if(scrollTop > 20) {
				Header.$domHeader.addClass(Header.classHeaderScroll);
			} else {
				Header.$domHeader.removeClass(Header.classHeaderScroll);
			}
		});
	},
};

export default Header;